import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-topsnap",
  "use": "icon-topsnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-topsnap\">\r\n<path d=\"M921.6 256 921.6 204.8 102.4 204.8l0 51.2L921.6 256zM819.2 716.8 819.2 307.2l-256 0 0 409.6L819.2 716.8zM460.8 358.4l0 512L256 870.4 256 358.4 460.8 358.4M512 307.2 204.8 307.2l0 614.4 307.2 0L512 307.2 512 307.2z\" p-id=\"1987\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol